import httpServiceAuth from '@/services/http-service';
import { apiEndpoints } from '@/services/constants';
import { errorHandler } from '@/services/error-handler';

export default {
  state: {
    help: {},
  },
  mutations: {
    setHelp(state, payload) {
      state.help = payload;
    },
  },
  actions: {
    getHelp({ commit }, route) {
      const url = `${apiEndpoints.company.help}`;

      return httpServiceAuth
        .post(url, { route }) // Send route as payload in POST body
        .then(({ data }) => {
          commit('setHelp', data.data);
        })
        .catch((error) => {
          if (error.response) {
            errorHandler(error.response);
          }
        });
    },
    getAllHelp({ commit }, route) {
      const url = `${apiEndpoints.company.allHelp}`;

      return httpServiceAuth
        .get(url, { route })
        .then(({ data }) => {
          const transformed = {};

          data.data.forEach((item) => {
            transformed[item.route] = { name: item.name, content: item.content };
          });

          commit('setHelp', transformed);
        })
        .catch((error) => {
          if (error.response) {
            errorHandler(error.response);
          }
        });
    },
  },
};
